module.exports = __webpack_public_path__ + "img/blocks-bar.5f51e001.svg";